import { NGN_FALLBACK } from '../actions/currencyActions';

const initialState = {
    currency: NGN_FALLBACK.symbol,
    currenciesRates: NGN_FALLBACK,
    currencies: [NGN_FALLBACK],
    loading: false,
};

const currencyReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_CURRENCY':
            return { ...state, currency: action.payload.currency };

        case 'SET_CURRENCIES_RATES':
            return { ...state, currenciesRates: action.payload };

        case 'SET_CURRENCIES':
            return { ...state, currencies: action.payload };

        case 'GET_CURRENCIES':
            return { ...state, loading: action.payload };

        default:
            return state;
    }
};

export default currencyReducer;
